import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog } from '@tom-ui/ui'
import { AllocationRuleDto, YardBlockDto } from '@yard/app/api'
import { AllocationRuleDestinationDialog } from '@yard/components/AllocationRules/components/organisms/AllocationRuleDestinationDialog'
import { AllocationRulesTable } from '@yard/components/AllocationRules/components/organisms/AllocationRulesTable'
import { mapYardPositionDestinationRangeToAllocationDestinationDto } from '@yard/components/AllocationRules/helpers/allocation-rule.mapper'
import { YardPositionBlockRange } from '@yard/components/YardPositionSelector/models/yard-position-block-range.model'
import { BaseAllocationRulesViewStore } from '@yard/pages/YardSetup/stores/allocation-rules/base-allocation-rules.view-store'
import { observer } from 'mobx-react-lite'
import { FC, useState } from 'react'

interface Props {
  allocationRulesViewStore: BaseAllocationRulesViewStore
  yardBlocks: YardBlockDto[]
}
export const AllocationRuleDialogImport: FC<Props> = observer(props => {
  const { allocationRulesViewStore, yardBlocks } = props
  const { t } = useTranslate()
  const [isDestinationDialogOpen, setIsDestinationDialogOpen] = useState(false)
  const [editedRule, setEditedRule] = useState<AllocationRuleDto | null>(null)
  const [hasError, setHasError] = useState(false)

  const handleCopy = (allocationRule: AllocationRuleDto) => {
    if (!allocationRule.destinations.length) {
      setIsDestinationDialogOpen(true)
      setEditedRule(allocationRule)
      return
    }

    allocationRulesViewStore.copyTemplateRule(allocationRule)
  }

  const handleDestionationConfirm = () => {
    if (editedRule && !editedRule.destinations.length) {
      setHasError(true)
      return
    }

    if (editedRule) {
      allocationRulesViewStore.copyTemplateRule(editedRule)
      setIsDestinationDialogOpen(false)
    }
  }

  const handleDestinationPositionChange = (position?: YardPositionBlockRange) => {
    if (editedRule) {
      setEditedRule({
        ...editedRule,
        destinations: position
          ? [mapYardPositionDestinationRangeToAllocationDestinationDto(position)]
          : [],
      })
    }
  }

  return (
    <>
      <ConfirmationDialog
        open={allocationRulesViewStore.isTemplateDialogOpen}
        title={t('allocationRulesTemplates', 'Allocation rule templates')}
        hidePrimaryAction
        primaryActionText=''
        closeLabel={t('close', 'Close')}
        onCancel={() => allocationRulesViewStore.toggleTemplateDialog()}
        onClose={() => allocationRulesViewStore.toggleTemplateDialog()}
        maxWidth='lg'
      >
        <AllocationRulesTable
          allocationRules={allocationRulesViewStore.templateRules}
          onCopy={handleCopy}
        />
      </ConfirmationDialog>

      <AllocationRuleDestinationDialog
        isOpen={isDestinationDialogOpen}
        yardBlocks={yardBlocks}
        hasError={hasError}
        onClose={() => setIsDestinationDialogOpen(false)}
        onConfirm={handleDestionationConfirm}
        onPositionChange={handleDestinationPositionChange}
      />
    </>
  )
})
